module.exports = __webpack_public_path__ + "static/logo-8ca14357674e213a23dc1c0682bf8032.png";